/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import Request from 'generic/request/Request'

export const CONSUMERS_URL = '/api/consumer/simple/list/'
const CONSUMER_URL = '/api/consumer/'

export function getConsumer(uid) {
  return Request.getRequest(CONSUMER_URL + (uid ? uid + '/' : ''))
    .then((result) => {
      return result.data.object
    })
}

export function postConsumer (consumer) {
  return Request.postRequest(CONSUMER_URL + (consumer.uid ? consumer.uid + '/' : ''), consumer)
    .then((result) => {
      return result.data.object
    })
}



// WEBPACK FOOTER //
// ./src/actions/Consumer.js